const components = {
  apps: {
    dash: ['pagarme'],
    hub: ['pagarme'],
    shop: ['pagarme'],
    pix: ['pagarme'],
    antifraud: ['pagarme']
  },
  logo: {
    pagarme: ['pagarme'],
    jpmorgan: ['jpmorgan']
  },
  global: {
    onboarding: ['pagarme']
  },
  globalError: {
    logo: ['pagarme']
  },
  footer: {
    textJPMorgan: ['jpmorgan'],
    textPagarme: ['pagarme'],
    switchThemeMode: [],
    status: ['pagarme'],
    help: ['pagarme'],
    documentation: ['pagarme', 'jpmorgan'],
    privacySecurity: ['jpmorgan'],
    urlSite: ['pagarme'],
    switchLanguage: ['pagarme', 'jpmorgan'],
    privacyPolicy: ['pagarme'],
    termsOfUse: ['pagarme'],
    secureEnv: ['pagarme', 'jpmorgan']
  },
  backofficeIcon: {
    pagarmeIcon: ['jpmorgan', 'pagarme']
  }
}

export default components
